import * as defaultConst from '../../../constants/default_constants'
import * as linkConst from '../../../constants/link_constants'
import Validators from './../validators'
import moment from 'moment'
import { BaseManipStateFn, BaseTableState } from './../base'
import { observable } from 'mobx'

export default (store) => {
  class ManipState extends BaseManipStateFn(store) {
    prepareNew () {
      if (!this.record.has('id')) {
        if (store.lastSaved && store.lastSaved.FPVCategories && store.lastSaved.FPVCategories.loadLast) {
          delete store.lastSaved.FPVCategories.id
          delete store.lastSaved.FPVCategories.control_timestamp
          if (store.lastSaved.FPVCategories.order) {
            store.lastSaved.FPVCategories.order = parseInt(store.lastSaved.FPVCategories.order) + 1
          }
          if (store.lastSaved.FPVCategories.valid_from &&
            moment(store.lastSaved.FPVCategories.valid_from) < moment()) {
            store.lastSaved.FPVCategories.valid_from = moment().format(defaultConst.DATE_FORMAT)
          }
          Object.keys(store.lastSaved.FPVCategories).map(key => {
            this.record.set(key, store.lastSaved.FPVCategories[key])
          })
          store.lastSaved.FPVCategories.loadLast = false
          store.addMessage('Data from the last save were retrieved', 'info')
        }
        this.record.set('control_timestamp', Math.round(new Date().getTime()))
        this.record.set('updated', new Date())
      }
    }

    save () {
      this.state = 'saving'
      // save _new item:
      if (!this.origRecordId) {
        const regions = this.record.has('regions') && this.record.get('regions')
        // save multiple items:
        if (regions && regions.indexOf(',') > 0) {
          const promises = []
          this.record.allRegions = regions
          regions.split(',').map(i => {
            const replacedItem = Object.assign({}, Object.fromEntries(this.record))
            replacedItem.regions = i
            promises.push(this.saveEntry(this.entityname, replacedItem, this.origRecordId)
              .then(this.onSaved.bind(this))
              .catch(this.onError.bind(this))
            )
          })
          return Promise.all(promises).then(() => {
            return this.flagEditDone(this.entityname, this.origRecordId)
          }).catch(store.onRequesterError.bind(store))
        // save one item:
        } else {
          return this.saveEntry(this.entityname, this.record, this.origRecordId)
            .then(this.onSaved.bind(this))
            .catch(this.onError.bind(this))
        }
      // save edited item:
      } else {
        return super.save()
      }
    }

    onSaved (saved) {
      if (this.record && this.record.allRegions) {
        saved.regions = this.record.allRegions
      }
      store.lastSaved = !store.lastSaved ? {} : store.lastSaved
      store.lastSaved.FPVCategories = saved
      store.markDirty(linkConst.LINK_CATEGORIES)
      return super.onSaved(saved)
    }

    requiredOptions = [
      'Countries',
      'FlyprivateCategories',
      'FlyPrivatePlatforms',
      linkConst.LOAD_OPTIONS.films,
      ['flyprivate_categories_settings',
        '/flyprivate_categories_settings?attrs=["id","enum_value","video_id","order","regions","valid_to","valid_from"]',
        'id'
      ]
    ]

    @observable platformFilter = null
    timeRestriction = 'flyprivate_categories_settings'
    createtitle = store.__(linkConst.LINK_CATEGORIES_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_CREATE)
    edittitle = store.__(linkConst.LINK_CATEGORIES_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_EDIT)
    validators = {
      enum_value: [
        Validators.isMandatory(store)
      ],
      video_id: [
        Validators.isMandatory(store)
      ],
      order: [
        Validators.isMandatory(store),
        Validators.positiveInt(store)
      ],
      regions: [
        Validators.isMandatory(store),
        Validators.regionTest(store)
      ],
      valid_from: [
        Validators.isMandatoryDate(store),
        Validators.isValidFromTo(store)
      ],
      valid_to: [
        Validators.isMandatoryDate(store),
        Validators.isValidFromTo(store)
      ],
      _global: [
        Validators.isWorldWideRegion(store, 'flyprivate_categories_settings'),
        (vals) => {
          const validFrom = vals.has('valid_from') && new Date(vals.get('valid_from'))
          const validTo = vals.has('valid_to') && new Date(vals.get('valid_to'))
          const items = store.options.get('flyprivate_categories_settings')
          const valsRegions = (vals.get('regions') && vals.get('regions').split(',')) || []

          if (vals.has('regions') && vals.get('regions') !== 'WW') {
            const regionWW = items.filter((item) => {
              const itemFrom = new Date(item.valid_from)
              const itemTo = new Date(item.valid_to)
              if (((item.id && vals.get('id') !== item.id) ||
              (item.control_timestamp && item.control_timestamp !== vals.get('control_timestamp'))) &&
              vals.has('enum_value') && vals.get('enum_value') === item.enum_value &&
              vals.has('video_id') && vals.get('video_id') === item.video_id &&
              item.regions === 'WW' && itemFrom <= validFrom && itemTo >= validTo
              ) {
                return item
              }
            })
            store.manipWarning = (!regionWW || !regionWW.length) || false
          } else {
            store.manipWarning = false
          }

          // validate distictive intervals of other record with same category
          const overlapping = items.filter((i) => {
            if ((vals.has('video_id') && vals.get('video_id') !== i.video_id) ||
                vals.get('enum_value') !== i.enum_value ||
                (vals.get('enum_value') === i.enum_value && !valsRegions.includes(i.regions)) ||
                (i.id && vals.get('id') === i.id) ||
                (i.control_timestamp && i.control_timestamp === vals.get('control_timestamp'))
            ) {
              return // cut off the row with wrong enum value and current item
            }
            const iFrom = new Date(i.valid_from)
            const iTo = new Date(i.valid_to)
            if (!((iFrom < validFrom) && (iTo < validFrom)) && !((iFrom > validTo) && (iTo > validTo))) {
              return i
            }
          })

          if (overlapping.length > 0) {
            return overlapping.map((item) => {
              return `${store.__('selected interval overlaps with category:')} ${item.enum_value}`
            })
          }
        }
      ]
    }
  }

  class TableState extends BaseTableState {
    attrs = [
      'id',
      'fp_platform_enumtext',
      'enum_value_enumtext',
      'video_title',
      'order',
      'regions',
      'valid_from',
      'valid_to'
    ]

    headertitles = [
      store.__('ID'),
      store.__('platform'),
      store.__('category'),
      store.__('film'),
      store.__('order'),
      store.__('region'),
      store.__('valid from'),
      store.__('valid to')
    ]

    timeRestriction = 'flyprivate_categories_settings'
    title = store.__(linkConst.LINK_CATEGORIES_TITLE)
    defaultSort = linkConst.DEFAULT_SORT[linkConst.LINK_CATEGORIES]

    requiredOptions = [
      'Countries',
      'FlyprivateCategories',
      'FlyPrivatePlatforms',
      linkConst.LOAD_OPTIONS.films
    ]
  }

  return { ManipState, TableState }
}
